module.exports = __webpack_public_path__ + "static/1-2dd5e11fe8ad43413eb75388b7b0decb.jpeg";